module.exports = __webpack_public_path__ + "img/c890cc45b70e68ee31a5e73e238d901d.svg";